import { api } from "./axios";
import {
  GetMarketingResourceTopicsParams,
  GetMarketingResourcesParams,
  MarketingResourceTopic,
  PaginatedMarketingResourcesResponse,
} from "../types";

export function getMarketingResources(
  params: GetMarketingResourcesParams = {}
): Promise<PaginatedMarketingResourcesResponse> {
  return api.get("marketing-resources/", {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
}

export function getMarketingResourceTopics(
  params: GetMarketingResourceTopicsParams = {}
): Promise<MarketingResourceTopic[]> {
  return api.get("marketing-resource-topics/", {
    params,
  });
}
